/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sch_Err_Workflow_In_UseInputs */

const en_sch_err_workflow_in_use = /** @type {(inputs: Sch_Err_Workflow_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} products use this workflow. Switch them to another workflow first.`)
};

const de_sch_err_workflow_in_use = /** @type {(inputs: Sch_Err_Workflow_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Produkte nutzen diesen Workflow. Stelle sie zuerst auf einen anderen Workflow um.`)
};

/**
* | output |
* | --- |
* | "{count} products use this workflow. Switch them to another workflow first." |
*
* @param {Sch_Err_Workflow_In_UseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_workflow_in_use = /** @type {((inputs: Sch_Err_Workflow_In_UseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Workflow_In_UseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_workflow_in_use(inputs)
	return en_sch_err_workflow_in_use(inputs)
});